import * as React from 'react';
import Ellipsis from 'ant-design-pro/lib/Ellipsis';
import { LayoutOutlined } from '@ant-design/icons';
import { nullSafeGet, nullSafeGetOrElse } from '../../utils/DataAccessUtils';
import { currencyFormatter, dateFormatter } from '../../utils/DataFormatterUtils';
import DateTimeHover from '../date_time_component/DateTime';
import HyperLink from '../common/HyperLink';
import OWLink from '../OWLink';

const style = require('./PlannedMaintenanceScheduleRowDisplay.less');

export const PlannedMaintenanceScheduleRowDisplay: React.FC<any> = ({
	plannedMaintenanceSchedule,
	userType,
	allowArea,
}) => {
	if (!plannedMaintenanceSchedule) {
		return null;
	}
	const { basedOn } = plannedMaintenanceSchedule;
	const linkFilter =
		basedOn === 'asset'
			? `assetIds=${nullSafeGet('asset.id', plannedMaintenanceSchedule)}`
			: basedOn === 'assetType'
			? `assetTypeIds=${nullSafeGet(
					'assetType.id',
					plannedMaintenanceSchedule
			  )}&locationIds=${nullSafeGet('location.id', plannedMaintenanceSchedule)}`
			: `locationIds=${nullSafeGet('location.id', plannedMaintenanceSchedule)}`;

	return (
		<div className="plannedMaintenanceSchedulesRowDisplay">
			<div>
				<div className="plannedMaintenanceSchedulesRowDisplay__rowTitle">
					{basedOn === 'asset' && nullSafeGet('asset.id', plannedMaintenanceSchedule) ? (
						<OWLink
							to={`/${userType}/assets/detail/${nullSafeGet(
								'asset.id',
								plannedMaintenanceSchedule
							)}/details`}
							target="_blank"
							rel="noreferrer"
							className="inline-flex items-center text-blue-600 underline visited:text-purple-600 hover:text-blue-800"
						>
							<Ellipsis tooltip={true} length={64}>
								{nullSafeGet('asset.name', plannedMaintenanceSchedule)}
							</Ellipsis>
							<i className="icons8-font icons8-external-link ml-2 inline-block" />
						</OWLink>
					) : (
						<Ellipsis tooltip={true} length={64}>
							{basedOn === 'asset'
								? nullSafeGet('asset.name', plannedMaintenanceSchedule)
								: basedOn === 'assetType'
								? `${nullSafeGet('assetType.name', plannedMaintenanceSchedule)} - ${nullSafeGet(
										'location.name',
										plannedMaintenanceSchedule
								  )}`
								: nullSafeGet('location.name', plannedMaintenanceSchedule)}
						</Ellipsis>
					)}
				</div>
				<div className="plannedMaintenanceSchedulesRowDisplay__rowSubtitle">
					<div className="plannedMaintenanceSchedulesRowDisplay__rowInlineGroup">
						<i className="icons8-font icons8-location-marker"></i>{' '}
						{nullSafeGet('location.name', plannedMaintenanceSchedule)}
						{nullSafeGet('location.storeId', plannedMaintenanceSchedule)
							? ` (#${plannedMaintenanceSchedule.location.storeId})`
							: ''}
					</div>
					{allowArea &&
					basedOn === 'asset' &&
					nullSafeGet('asset.area', plannedMaintenanceSchedule) ? (
						<div className="plannedMaintenanceSchedulesRowDisplay__rowInlineGroup">
							<LayoutOutlined />{' '}
							{nullSafeGetOrElse(
								'asset.area.hierarchyName',
								plannedMaintenanceSchedule,
								nullSafeGet('asset.area.name', plannedMaintenanceSchedule)
							)}
						</div>
					) : null}
					{plannedMaintenanceSchedule.nte ||
					nullSafeGet('plannedMaintenanceTemplate.nte', plannedMaintenanceSchedule) ? (
						<div className="plannedMaintenanceSchedulesRowDisplay__rowInlineGroup">
							NTE:{' '}
							{currencyFormatter(2)(
								plannedMaintenanceSchedule.nte ||
									nullSafeGet('plannedMaintenanceTemplate.nte', plannedMaintenanceSchedule)
							)}
						</div>
					) : null}
					{plannedMaintenanceSchedule.supplierFacilityId ||
					nullSafeGet(
						'plannedMaintenanceTemplate.supplierFacilityId',
						plannedMaintenanceSchedule
					) ? (
						<div className="plannedMaintenanceSchedulesRowDisplay__rowInlineGroup">
							<i className="icons8-font icons8-company"></i>{' '}
							{nullSafeGet('routeToSupplier.displayName', plannedMaintenanceSchedule)}
						</div>
					) : null}
					{plannedMaintenanceSchedule.scheduleId ? (
						<div className="plannedMaintenanceSchedulesRowDisplay__rowSubtitle">
							{`Schedule ID : ${plannedMaintenanceSchedule.scheduleId}`}
						</div>
					) : null}
					{plannedMaintenanceSchedule.status === 'active' &&
					(plannedMaintenanceSchedule.nextScheduled ||
						nullSafeGet('createConfig', plannedMaintenanceSchedule) ===
							'create_after_prior_completion') ? (
						<div className="plannedMaintenanceSchedulesRowDisplay__rowInlineGroup">
							{plannedMaintenanceSchedule.nextScheduled ? (
								<>
									Next service on{' '}
									<DateTimeHover
										timestamp={nullSafeGet('nextScheduled', plannedMaintenanceSchedule)}
										showDate={true}
										showTime
										timeZone={nullSafeGet('location.timeZoneId', plannedMaintenanceSchedule)}
									/>
								</>
							) : (
								'Next service will be scheduled once current work order is marked complete'
							)}
						</div>
					) : null}
				</div>
				<div className="flex flex-row gap-x-6">
					<HyperLink
						text="All Work Orders"
						newTabPath={`/${userType}/workOrders/overview/all?plannedMaintenanceScheduleId=${plannedMaintenanceSchedule.id}&${linkFilter}`}
					/>
					<HyperLink
						text="Active Work Orders"
						newTabPath={`/${userType}/workOrders/overview/active?plannedMaintenanceScheduleId=${plannedMaintenanceSchedule.id}&${linkFilter}`}
					/>
				</div>
			</div>
			<div className="plannedMaintenanceSchedulesRowDisplay__rightSide">
				<div className="plannedMaintenanceSchedulesRowDisplay__rowTitle"></div>
			</div>
		</div>
	);
};
